export default {
  large: 'body-16',
  small: 'body-14',
  'extra-small': 'caption-12',
}
